import { render, staticRenderFns } from "./RecoverPasswordView.vue?vue&type=template&id=9943a2fc&scoped=true&lang=pug&"
import script from "./RecoverPasswordView.vue?vue&type=script&lang=js&"
export * from "./RecoverPasswordView.vue?vue&type=script&lang=js&"
import style0 from "./RecoverPasswordView.vue?vue&type=style&index=0&id=9943a2fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9943a2fc",
  null
  
)

export default component.exports